import script from "./MaterialCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialCenter.vue?vue&type=script&setup=true&lang=js"

import "./MaterialCenter.vue?vue&type=style&index=0&id=4309ee29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4309ee29"]])

export default __exports__